// src/whatsappChat/pages/SetupPage.jsx
import React from 'react';
import { useWaSetupCheck } from '../api/hooks';
import { normalizeError } from '../api/client';
import { PromptEditor } from '../components/PromptEditor';
import { ChatTemplatesPanel } from '../components/ChatTemplatesPanel';
import '../styles/inbox.css';
import '../styles/compose.css';
import '../styles/templates.css';

export default function SetupPage() {
  const { data: numbers = [], isLoading, isFetching, isError, error, refetch } = useWaSetupCheck();

  return (
    <section className="wa-page">
      <div className="wa-page-head">
        <div>
          <h1 className="wa-page-title">Setup</h1>
          <p className="wa-page-sub">Configured business numbers, checked against BotSense.</p>
        </div>
        <button
          type="button"
          className="wa-btn wa-btn-primary"
          onClick={() => refetch()}
          disabled={isFetching}
        >
          {isFetching ? 'Checking…' : 'Re-check'}
        </button>
      </div>

      <div className="wa-card">
        {isLoading ? (
          <div className="wa-state">Checking numbers…</div>
        ) : isError ? (
          <div className="wa-state">{normalizeError(error).message}</div>
        ) : numbers.length === 0 ? (
          <div className="wa-state">No business numbers are configured.</div>
        ) : (
          <table className="wa-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Number ID</th>
                <th>Status</th>
                <th>Detail</th>
              </tr>
            </thead>
            <tbody>
              {numbers.map((n) => (
                <tr key={n.number_id}>
                  <td className="wa-strong">{n.name || '—'}</td>
                  <td className="wa-mono">{n.number_id}</td>
                  <td>
                    <span className={`wa-pill ${n.ok ? 'wa-pill-success' : 'wa-pill-danger'}`}>
                      {n.ok ? 'Connected' : 'Failed'}
                    </span>
                  </td>
                  <td className="wa-muted">{n.ok ? 'Key accepted by BotSense' : n.error || 'Unknown error'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div className="wa-setup-section">
        <h2 className="wa-setup-heading">Prompts</h2>
        <p className="wa-page-sub">Used when generating suggested replies in the inbox.</p>
        <div className="wa-setup-prompts">
          <PromptEditor type="system" />
          <PromptEditor type="user" />
        </div>
      </div>

      <div className="wa-setup-section">
        <h2 className="wa-setup-heading">Chat Templates</h2>
        <p className="wa-page-sub">Saved replies that can be dropped into the message box from a chat.</p>
        <div className="wa-card wa-card-pad wa-setup-templates">
          <ChatTemplatesPanel />
        </div>
      </div>
    </section>
  );
}
